const getNestedValue = (obj, path) => {
  return path
    .split(".")
    .reduce((acc, key) => (acc ? acc[key] : undefined), obj);
};

const flattenErrors = (obj, prefix = "") => {
  let result = {};
  if (
    typeof obj === "string" ||
    typeof obj === "number" ||
    typeof obj === "boolean"
  ) {
    // Leaf node (actual error message)
    result[prefix] = true;
  } else if (Array.isArray(obj)) {
    obj.forEach((item, idx) => {
      const newPrefix = prefix ? `${prefix}.${idx}` : `${idx}`;
      Object.assign(result, flattenErrors(item, newPrefix));
    });
  } else if (typeof obj === "object" && obj !== null) {
    Object.keys(obj).forEach((key) => {
      const newPrefix = prefix ? `${prefix}.${key}` : key;
      Object.assign(result, flattenErrors(obj[key], newPrefix));
    });
  }
  return result;
};

/**
 * Validates the current step of a multi-step form and handles navigation.
 *
 * @param {object} formik - The Formik instance used for form state management.
 * @param {string[]} fields - An array of field paths to validate in the current step. Each path should be a string representing
 *                            the nested structure of the field
 */
export const pageFormValidation = async (formik, fields) => {
  const errors = await formik.validateForm();

  // Filter errors to only those in the current step
  const stepErrors = {};
  fields.forEach((fieldPath) => {
    const error = getNestedValue(errors, fieldPath);
    if (error) {
      stepErrors[fieldPath] = error;
    }
  });

  // Touch fields with errors so Formik shows them in the UI
  if (Object.keys(stepErrors).length > 0) {
    formik.setTouched(flattenErrors(stepErrors), true);
    return false;
  }

  return true;
};
